import { NavItemType } from 'types';
import dashboardAdmin from './dashboardadmin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboardAdmin]
};

export default menuItems;
